import { action, computed, observable } from "mobx";
import {
  login,
  weChatServerBinding,
} from "@/services/accountRelated";
import { checkMobile, checkPassword, checkVcode } from "@/utils/checkInput";
import {
  mobileErrText,
  passwordErrText,
  vcodeErrText
} from "@/utils/constants";
import router from "@/router";
import GlobalStore from "@/store/GlobalStore";
import log from "@/utils/log";

class BindUserStore {
  /**
   * 登录后用户信息
   */
  @observable userInfo;

  @observable inputError = {
    text: "",
    type: ""
  };


  //微信服务号绑定请求参数
  @observable weixinBindpaarams = {
    openId: '',
    account: "",
    password: "",
    channel: GlobalStore.channel,
  };
  //微信服务号绑定后信息
  @observable weixinBindInfo;

  /**
   * 账号信息
   */
  @observable accountInfo = {
    account: "",
    password: "",
    clientType: 6,
    loginType: 5,
    channel: GlobalStore.channel
  };

  @observable toast = GlobalStore.toast;

  // 账户是否已绑定
  @observable isBindUser = false;

  // 账户是否已解绑
  @observable isUnBindUser = true;

  // 进入云手机
  @action.bound enterClouds() {
    router.push({ path: "home" });
  }

  @action.bound inputOnChange(value: string, name: string) {
    this.accountInfo = Object.assign({}, this.accountInfo, { [name]: value });
  }

  @action.bound routerPushSignUp() {
    router.push({ path: "signup" });
  }

  @action.bound routerPushForgotPassword() {
    router.push({ path: "forgotpassword" });
  }

  @action.bound setCookie(cookie) {
    document.cookie = cookie
      ? `auth_info=${cookie};path=/`
      : `auth_info=${cookie}`;
  }

  // h5微信服务号绑定
  @action.bound async weChatServerBinding(path:any) {
    const { account, password } = this.accountInfo;
    if (!checkMobile(account)) {
      this.toast.text(mobileErrText);
      this.inputError = { text: mobileErrText, type: "account" };
      return false;
    }

    if (!checkPassword(password)) {
      this.toast.text(passwordErrText);
      this.inputError = { text: passwordErrText, type: "password" };
      return false;
    }
    this.weixinBindpaarams.account = account;
    this.weixinBindpaarams.password = password;
    console.log(this.weixinBindpaarams);

    this.inputError = { text: "", type: "" };
    const loading = this.toast.loading();

    if(sessionStorage.getItem('openId')) {
      (this.weixinBindpaarams as any).openId = sessionStorage.getItem('openId')
    }

    this.weixinBindInfo = await weChatServerBinding(this.weixinBindpaarams);
    loading.hide();
    console.log(this.weixinBindInfo);

    if (this.weixinBindInfo.code !== 10000) {
      this.toast.text(this.weixinBindInfo.msg);
      return false;
    }

    window.localStorage.setItem("account", this.weixinBindInfo.result.account);
    window.localStorage.setItem("userId", this.weixinBindInfo.result.uid);

    this.setCookie(this.weixinBindInfo.result.authInfoStr);
    this.isBindUser = true;
    if (path) {
      router.push({ path})
    }
    // router.push({ path: "home" });
  }
}

export default new BindUserStore();
